export default __webpack_public_path__ + "static/media/AmericaCelebrationSquiggles.74e9a341.png";